/** List of known extension keys on the CustomFieldChoice */ export var CustomFieldChoiceExtensionKeys = /*#__PURE__*/ function(CustomFieldChoiceExtensionKeys) {
    /** The extension key for the order hint data (orderHint string wrapped in JSON) */ CustomFieldChoiceExtensionKeys["orderHintData"] = "orderHintData";
    /** The extension key for the color data (backgroundColor and foregroundColor) */ CustomFieldChoiceExtensionKeys["colorData"] = "colorData";
    return CustomFieldChoiceExtensionKeys;
}({});
